import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromApp from '@store';
import { UserService } from '@core/api/user.service';

export interface DialogData {
  title: string;
  line1: string;
  line1Color: string;
  line2: string;
  line2Color: string;
  line3: string;
  line3Color: string;
  bullets: string[];
  bulletsColor: string;
  bulletsClass: string;
  buttonTextNo: string;
  buttonStyleNo: string;
  buttonTextYes: string;
  buttonStyleYes: string;
  logActivity: any;
}

@Component({
  selector: 'fc-dialog-yes-no',
  templateUrl: './dialog-yes-no.component.html',
  styleUrls: ['./dialog-yes-no.component.scss'],
  standalone: false
})
export class DialogYesNoComponent {
  constructor(
    public store: Store<fromApp.AppState>, public dialogRef: MatDialogRef<DialogYesNoComponent>,
    readonly userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  onClick(buttonYes: boolean = false): void {
    if (this.data.logActivity) {
      this.userService.logUserActivity({
        ...this.data.logActivity,
        details: `${this.data.logActivity['details'] || this.data.title}: Clicked ${buttonYes ? 'Yes' : 'No'}`,
      });
    }
    this.dialogRef.close(buttonYes);
  }
}
